import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const UnidadesDeAprendizagemDefault = Default;

export default UnidadesDeAprendizagemDefault;
export const UnidadesDeAprendizagemAdicionar = Adicionar;
export const UnidadesDeAprendizagemEditar = Editar;
